import { withTopbarPortal } from '$utils'

import Topbar from './Topbar'

const PortaledTopbar = withTopbarPortal(Topbar)

/**
 * Entry point for the React-owned topbar. This is mounted from `app.tsx` as a
 * sibling of the `RouterProvider` so the topbar is always present regardless of
 * the active React route (it is intentionally NOT part of the route tree).
 *
 * It is portaled into the persistent `#loaded-topbar` mount node in the host
 * page and renders unconditionally.
 */
const TopbarPortal = () => <PortaledTopbar />

export default TopbarPortal
